var React = require('react');

function EllipsisH (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}));
}

EllipsisH.defaultProps = {"viewBox":"0 0 320 512"};

module.exports = EllipsisH;

EllipsisH.default = EllipsisH;
